<template>
    <v-flex xs12 xl8 class="content">
        <slot v-if="appLoaded"></slot>
    </v-flex>
</template>

<script>
    export default {
        name: "MainContentWrapper",
        methods: {
            appLoaded(){
                return this.$store.state.application.loaded;
            }
        }
    }
</script>

<style scoped>

</style>